import { FormInputProps } from "../../types/formInputProps"
import FormInputDropdown from "./form-component/FormInputDropDown"


interface ZodiakProps extends Omit<FormInputProps, 'label'> {
    forceValidate?: boolean
}

const ZodiakList = ({ name, control, setValue, forceValidate }: ZodiakProps) => {
    const ZodiakArr = [
        { value: 'Овен' },
        { value: 'Телец' },
        { value: 'Близнецы' },
        { value: 'Рак' },
        { value: 'Лев' },
        { value: 'Дева' },
        { value: 'Весы' },
        { value: 'Скорпион' },
        { value: 'Стрелец' },
        { value: 'Козерог' },
        { value: 'Водолей' },
        { value: 'Рыбы' },
        { value: 'Не знаю' },
    ]

    return (
        <>
            <FormInputDropdown
                name={name}
                control={control}
                setValue={setValue}
                label="Выберите знак"
                options={ZodiakArr}
                forceValidate={forceValidate}
            />
        </>
    )
}

export default ZodiakList
